/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { camelCaseToRegularForm, capitalizeFirstLetter } from 'serenova-js-utils/strings';
import moment from 'moment';

import styled from 'styled-components';
import { SearchIconSVG } from 'cx-ui-components';

const Input = styled.input`
  width: 100%;
`;
const SearchIcon = styled(SearchIconSVG)`
  position: relative;
  left: -17px;
  opacity: 0.4;
`;

function convertUTCDateToLocalDate(date) {
  var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

  var offset = date.getTimezoneOffset() / 60;
  var hours = date.getHours();

  newDate.setHours(hours - offset);

  return newDate;   
}

export function constructGeneralDateColumn(string, customString) {
  const normalizedString = customString ? camelCaseToRegularForm(customString) : camelCaseToRegularForm(string);
  const column = {
    id: string,
    Header: <span title={normalizedString}>{normalizedString}</span>,
    accessor: string,
    Cell: ({ row }) => {
        var date = convertUTCDateToLocalDate(new Date(row[string]));
        return <span title={row[string]}>{moment(date).format('lll')}</span>;
      
    },
    Filter: ({ filter, onChange }) => (
      <div>
        <Input
          className={`${normalizedString}-filter-input`}
          data-automation={`search${capitalizeFirstLetter(string)}Column`}
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ''}
          placeholder={normalizedString}
        />
        <SearchIcon searchIconType="primary" size={10} />
      </div>
    )
  };

  column.Cell.propTypes = {
    row: PropTypes.any
  };
  column.Filter.propTypes = {
    filter: PropTypes.func,
    onChange: PropTypes.func
  };

  return column;
}
